import React from "react";
import { CheckCircle } from "lucide-react";

const PlanFeaturesList = ({ newPlan }) => (
  <div className="space-y-2 text-sm">
    <h4 className="font-semibold text-foreground">
      With the {newPlan.name} plan, you'll get:
    </h4>
    <ul className="list-none space-y-1 text-muted-foreground">
      {newPlan.features.slice(0, 4).map((feature, index) => (
        <li key={index} className="flex items-center gap-2">
          <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
          <span>{feature}</span>
        </li>
      ))}
      <li className="flex items-center gap-2 font-medium text-foreground/80">
        <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
        <span>And much more!</span>
      </li>
    </ul>
  </div>
);

export default React.memo(PlanFeaturesList);
